export const pinValidator = (value) => {
    value = value.replace("-", "");
    if (value.length > 10 && value.match(/^19|^20/)) {
        value = value.replace(/^19|^20/g, "");
    }
    else {
        return false;
    }
    // kontrollerar kontrollsiffran
    if (!value.match(/^\d{10}$/))
        return false;
    var siffra = 0, // varje delsiffra i pnr
    ental = 0, // entalet (när siffra större än 9)
    kNummer = 0, // den siffra som SKALL varasist i pnr
    summa = 0, // summan av samtliga siffror
    testSumma = 0, // för att plocka ut tiotalet ur summan
    i = 0, // loop för utplockning av varje delsiffra i pnr
    tiotal = 0; // loop för att leta antalet tiotal
    // STEG 1 kontrollerar och summerar siffra för siffra i pnr
    for (i = 0; i < 9; i++) {
        siffra = parseInt(value.charAt(i));
        // multiplicerar siffran med 2 varannan gång
        if (i % 2 == 0) {
            siffra = siffra * 2;
        }
        // multiplicerar siffran med 1 varannan gång
        else {
            siffra = siffra * 1;
        }
        // om den nyligen multiplicerade siffran är ett ENTAL
        if (siffra < 10) {
            summa = summa + siffra;
        }
        // om den nyligen multiplicerade siffran är ett TIOTAL
        else {
            ental = siffra - 10;
            summa = summa + 1 + ental;
        }
    }
    // STEG 2, räknar ut kontroll-siffran
    testSumma = summa;
    while (testSumma > 9) {
        testSumma = testSumma - 10;
        tiotal++;
    }
    tiotal = tiotal + 1; // ökar på till närmast högre
    tiotal = tiotal * 10; // ger det fullständiga tiotalet
    kNummer = tiotal - summa; // kontrollsiffran blir närmast högre tiotal - summan
    // om kontrollSiffran är ett tiotal är andra siffran entalet, (dvs alltid 0)
    if (kNummer % 10 == 0)
        kNummer = 0;
    // STEG 3, kontrollerar att kontroll-siffran stämmer med sista siffran i personnummret
    if (kNummer == parseInt(value.charAt(9)))
        return true;
    //numret är OGILTLIGT
    return false;
};
export const validateOrgNumber = (orgNumber) => {
    const cleanedOrgNumber = orgNumber.replace(/[\s\-]/g, "");
    const isValidFormat = /^[0-9]{10}$/.test(cleanedOrgNumber);
    if (!isValidFormat) {
        return false;
    }
    const controlDigit = parseInt(cleanedOrgNumber.charAt(9), 10);
    const sum = cleanedOrgNumber
        .slice(0, 9)
        .split("")
        .map((digit, index) => parseInt(digit, 10) * (index % 2 === 0 ? 2 : 1))
        .join("")
        .split("")
        .map((digit) => parseInt(digit, 10))
        .reduce((acc, value) => acc + value, 0);
    const isValidControlDigit = (10 - (sum % 10)) % 10 === controlDigit;
    return isValidControlDigit;
};
const facilityIdValidator = (value) => {
    if (!value.match(/^735999/))
        value = "735999" + value;
    if (value.length < 17)
        return false;
    if (!value.match(/^735999[0-9]{12}$/))
        return false;
    var field = value.substring(0, 17), faktor = 3, index, sum = 0;
    for (index = 18 - 1; index > 0; --index) {
        sum += field.substring(index - 1, index) * faktor;
        sum = sum % 10;
        faktor = 4 - faktor;
    }
    var k = (10 - sum) % 10;
    if (k != value.substring(17, 18))
        return false;
    return true;
};
const validator = (source, tests, validator) => {
    for (const [key, value] of Object.entries(tests)) {
        if (key in source) {
            let valid = value(String(source[key]));
            validator.errors[key] = !valid;
            if (!valid) {
                validator.valid = false;
            }
        }
        else {
            validator.valid = false;
        }
    }
    return validator;
};
const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneReg = /^\+(?:[0-9]●?){6,14}[0-9]$/;
export const personValidator = (person, contact = false) => {
    let errors = { valid: true, errors: {} };
    errors = validator(person, contact ? contactTests : personTests, errors);
    person.valid = errors.valid;
    return errors;
};
export const emailValidator = (email) => {
    return emailReg.test(String(email).toLowerCase());
};
export const validateFacility = (facility) => {
    let errors = { valid: true, errors: {} };
    if (facility.powerOfAttorney === true) {
        facility.valid = true;
        return errors;
    }
    else if (facility.powerOfAttorney === false) {
        errors = validator(facility, facilityTests, errors);
        facility.valid = errors.valid;
        return errors;
    }
    else {
        errors.valid = false;
        facility.valid = false;
        return errors;
    }
};
export const validateInformation = (information) => {
    let errors = { valid: true, errors: {} };
    errors = validator(information, informationTests, errors);
    information.valid = errors.valid;
    return errors;
};
export const validateCompanyInformation = (information) => {
    let errors = { valid: true, errors: {} };
    errors = validator(information, companyInformationTests, errors);
    information.valid = errors.valid;
    return errors;
};
export const validateInvoice = (selectedInvoice) => {
    if (selectedInvoice === undefined || selectedInvoice === null) {
        return false;
    }
    if (selectedInvoice.label == "E-postadress") {
        return selectedInvoice.value && emailReg.test(String(selectedInvoice.value).toLowerCase());
    }
    else if (selectedInvoice.label == "Mobilnummer") {
        return selectedInvoice.value && phoneReg.test(String(selectedInvoice.value).toLowerCase());
    }
    else {
        return true;
    }
};
// Test here
const addressTests = {
    address: (address) => address.length,
    city: (city) => city.length,
    zipcode: (zipcode) => zipcode.length == 5,
};
const companyTests = {
    orgNumber: (orgNumber) => orgNumber.length == 10,
    companyName: (companyName) => companyName.length,
    address: (address) => address.length,
    zipcode: (zipcode) => zipcode.length,
    city: (city) => city.length,
};
const contactTests = {
    email: (email) => emailReg.test(String(email).toLowerCase()),
    mobile: (mobile) => mobile.length > 7,
    firstname: (firstname) => firstname.length,
    lastname: (lastname) => lastname.length,
};
const facilityTests = {
    areaId: (id) => id.length == 3 && !/\d/.test(id),
    facilityId: (id) => facilityIdValidator(id),
};
const informationTests = Object.assign({}, addressTests);
const companyInformationTests = Object.assign({}, companyTests);
const personTests = Object.assign(Object.assign({}, contactTests), addressTests);
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
